import React, {ReactElement} from 'react'
import FacilitiesRepository from '../components/facilities/FacilitiesRepository'
import AdminSearchFacilitiesPage from '../components/facilities/AdminSearchFacilitiesPage'
import AdminRegisterEquipmentPage from '../components/equipments/AdminRegisterEquipmentPage'
import {EquipmentsRepository} from '../components/equipments/EquipmentsRepository'
import AdminEquipmentDetailsPage from '../components/equipments/AdminEquipmentDetailsPage'
import EventEmitterExAdmin from '../components/shared/pageBaseComponents/EventEmitterExAdmin'
import AdminRegisterFacilityPage from '../components/facilities/AdminRegisterFacilityPage/AdminRegisterFacilityPage'
import FacilityModel from '../components/facilities/FacilityModel'
import AdminEquipmentsListPage from '../components/equipments/AdminEquipmentsListPage'
import AdminEditEquipmentPage from '../components/equipments/AdminEditEquipmentPage'
import AdminFacilityDetailsPage from '../components/facilities/AdminFacilityDetailsPage'
import AdminEditFacilityPage from '../components/facilities/AdminEditFacilityPage'
import {ReservationsRepositoryForAdmin} from '../components/reservations/admin/ReservationsRepositoryForAdmin'
import NatRoomToResidentRepo from '../__NoAutomatedTests/components/roomToResident/repository/NatRoomToResidentRepo'
import NatRoomNumberRepo from '../__NoAutomatedTests/components/roomNumber/repository/NatRoomNumberRepo'
import NatRidgeRepo from '../__NoAutomatedTests/components/ridge/repository/NatRidgeRepo'
import ARDetailsView from '../components/reservations/admin/AdminReserveComponents/ARDetailsView'
import {ReservationClass} from '../components/reservations/ReservationInterfaces'
import AdminManagerReserveSelectUserPage from '../components/reservations/admin/AdminManagerReserveSelectUserPage'
import AdminReserveSelectFacilityPage from '../components/reservations/admin/AdminReserveSelectFacilityPage'
import AdminAgentReserveSelectUserPage from '../components/reservations/admin/AdminAgentReserveSelectUserPage'
import AdminReserveSelectOptionPage from '../components/reservations/admin/AdminReserveSelectOptionPage'
import AdminReserveConfirmPage from '../components/reservations/admin/AdminReserveConfirmPage'
import AdminReserveCompletePage from '../components/reservations/admin/AdminReserveCompletePage'
import AdminUserRepository from '../components/adminUser/AdminUserRepository'
import NatCurrentDateTimeRepo from '../__NoAutomatedTests/components/currentDateTime/repository/NatCurrentDateTimeRepo'
import HolidaysRepository from '../components/HolidaysRepository'
import AdminRegisterMeetingPage from '../components/assocDirector/AdminRegisterMeetingPage'
import {MeetingRepositoryForAdmin} from '../components/assocDirector/MeetingRepositoryForAdmin'
import AdminMeetingListPage from '../components/assocDirector/AdminMeetingListPage'
import AdminEditMeetingPage from '../components/assocDirector/AdminEditMeetingPage'
import NatAdminUserRepo from '../__NoAutomatedTests/components/adminUser/repository/NatAdminUserRepo'
import AdminMeetingNotificationListPage
    from '../components/notificationReceiveSetting/AdminMeetingNotificationReceiveListPage'
import {
    AdminNotificationReceiveSettingRepo,
} from '../components/notificationReceiveSetting/AdminNotificationReceiveSettingRepo'
import NatCondominiumGroupRepo
    from '../__NoAutomatedTests/components/condominiumGroup/repository/NatCondominiumGroupRepo'
import AdminAssocDirectorListPage from '../components/assocDirector/AdminAssocDirectorListPage'
import AssocDirectorRepository from '../components/assocDirector/AssocDirectorRepository'
import AssocManagementRepository from '../components/assocDirector/AssocManagementRepository'
import AdminAssocTermListPage from '../components/assocDirector/AdminAssocTermListPage'
import AdminRegisterAssocTermPage from '../components/assocDirector/AdminRegisterAssocTermPage'
import AdminEditAssocTermPage from '../components/assocDirector/AdminEditAssocTermPage'
import AdminRegisterAssocDirectorPage from '../components/assocDirector/AdminRegisterAssocDirectorPage'
import AdminAssocDirectorPositionListPage from '../components/assocDirector/AdminAssocDirectorPositionListPage'
import AdminSupportSpTestPage from '../components/sample/AdminSupportSpTestPage'
import NatCondominiumRepo from '../__NoAutomatedTests/components/condominium/repository/NatCondominiumRepo'
import {Route} from 'react-router-dom'
import RouterPropsInjector from '../components/shared/RouterPropsInjector'
import AdminUnitOwnerListPage from '../components/generalMeeting/AdminUnitOwnerListPage'
import AdminGeneralMeetingRepo from '../components/generalMeeting/AdminGeneralMeetingRepo'
import {NatFileRepo} from '../__NoAutomatedTests/components/files/repository/NatFileRepo'
import AdminVotingRightsCountBulkUpdatePage from '../components/generalMeeting/AdminVotingRightsCountBulkUpdatePage'
import AdminGeneralMeetingRegisterPage from '../components/generalMeeting/AdminGeneralMeetingRegisterPage'
import AdminGeneralMeetingListPage from '../components/generalMeeting/AdminGeneralMeetingListPage'
import AdminGeneralMeetingDetailPage from '../components/generalMeeting/AdminGeneralMeetingDetailPage'
import AdminGeneralMeetingEditPage from '../components/generalMeeting/AdminGeneralMeetingEditPage'
import AdminUnitOwnerConfirmationKeyIssuePage from '../components/generalMeeting/AdminUnitOwnerConfirmationKeyIssuePage'

export interface RoutesAdminProps {
    facilitiesRepo: FacilitiesRepository
    equipmentsRepo: EquipmentsRepository
    reservationsRepoForAdmin: ReservationsRepositoryForAdmin
    ridgeRepo: NatRidgeRepo
    roomNumberRepo: NatRoomNumberRepo
    roomToResidentRepo: NatRoomToResidentRepo
    adminUserRepo: AdminUserRepository
    eventEmitter: EventEmitterExAdmin
    facilityModel: FacilityModel
    currentDateTimeRepo: NatCurrentDateTimeRepo
    holidaysRepo: HolidaysRepository
    meetingRepoForAdmin: MeetingRepositoryForAdmin
    adminNotificationReceiveSettingRepo: AdminNotificationReceiveSettingRepo
    natAdminUserRepo: NatAdminUserRepo
    natCondominiumGroupRepo: NatCondominiumGroupRepo
    assocManagementRepo: AssocManagementRepository
    assocDirectorRepo: AssocDirectorRepository
    natCondominiumRepo: NatCondominiumRepo
    adminGeneralMeetingRepo: AdminGeneralMeetingRepo
    natFileRepo: NatFileRepo
}

export function RoutesAdmin(routesProps: RoutesAdminProps): ReactElement {
    return (<>
        <Route
            path="/admin/condominiums/:id/facilities/search"
            element={<RouterPropsInjector>{(props) =>
                <AdminSearchFacilitiesPage
                    {...routesProps}
                    navigate={props.navigate}
                    location={props.location}
                    condominiumCd={props.params.id!}
                    pageTitle={'施設検索 | 素敵ネット 管理画面'}
                    headingAreaTitle={'施設一覧'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/condominiums/:id/facilities/register"
            element={<RouterPropsInjector>{(props) =>
                <AdminRegisterFacilityPage
                    {...routesProps}
                    condominiumCd={props.params.id!}
                    navigate={props.navigate}
                    pageTitle={'施設登録 | 素敵ネット 管理画面'}
                    headingAreaTitle={'施設登録'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/condominiums/:condominiumCd/facilities/:facilityId"
            element={<RouterPropsInjector>{(props) =>
                <AdminFacilityDetailsPage
                    {...routesProps}
                    condominiumCd={props.params.condominiumCd!}
                    facilityId={Number(props.params.facilityId!)}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'施設詳細 | 素敵ネット 管理画面'}
                    headingAreaTitle={'施設詳細'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/condominiums/:condominiumCd/facilities/:facilityId/edit"
            element={<RouterPropsInjector>{(props) =>
                <AdminEditFacilityPage
                    {...routesProps}
                    condominiumCd={props.params.condominiumCd!}
                    facilityId={Number(props.params.facilityId!)}
                    navigate={props.navigate}
                    pageTitle={'施設編集 | 素敵ネット 管理画面'}
                    headingAreaTitle={'施設編集'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/condominiums/:condominiumCd/equipments"
            element={<RouterPropsInjector>{(props) =>
                <AdminEquipmentsListPage
                    {...routesProps}
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'設備一覧 | 素敵ネット 管理画面'}
                    headingAreaTitle={'設備一覧'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/condominiums/:condominiumCd/equipments/register"
            element={<RouterPropsInjector>{(props) =>
                <AdminRegisterEquipmentPage
                    {...routesProps}
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    pageTitle={'設備登録 | 素敵ネット 管理画面'}
                    headingAreaTitle={'設備登録'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/condominiums/:condominiumCd/equipments/:equipmentId"
            element={<RouterPropsInjector>{(props) =>
                <AdminEquipmentDetailsPage
                    {...routesProps}
                    condominiumCd={props.params.condominiumCd!}
                    equipmentId={Number(props.params.equipmentId!)}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'設備詳細 | 素敵ネット 管理画面'}
                    headingAreaTitle={'設備詳細'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/condominiums/:condominiumCd/equipments/:equipmentId/edit"
            element={<RouterPropsInjector>{(props) =>
                <AdminEditEquipmentPage
                    {...routesProps}
                    condominiumCd={props.params.condominiumCd!}
                    equipmentId={Number(props.params.equipmentId!)}
                    navigate={props.navigate}
                    pageTitle={'設備編集 | 素敵ネット 管理画面'}
                    headingAreaTitle={'設備編集'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/condominiums/:condominiumCd/agent-reserve/select-facility"
            element={<RouterPropsInjector>{(props) =>
                <AdminReserveSelectFacilityPage
                    {...routesProps}
                    classification={ReservationClass.AGENT}
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'施設予約TOP | 素敵ネット 管理画面'}
                    headingAreaTitle={'代行予約'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/condominiums/:condominiumCd/agent-reserve/select-user"
            element={<RouterPropsInjector>{(props) =>
                <AdminAgentReserveSelectUserPage
                    {...routesProps}
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'利用者・支払方法選択 | 素敵ネット 管理画面'}
                    headingAreaTitle={'代行予約'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/condominiums/:condominiumCd/agent-reserve/select-option"
            element={<RouterPropsInjector>{(props) =>
                <AdminReserveSelectOptionPage
                    {...routesProps}
                    classification={ReservationClass.AGENT}
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'オプション選択 | 素敵ネット 管理画面'}
                    headingAreaTitle={'代行予約'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/condominiums/:condominiumCd/agent-reserve/confirm"
            element={<RouterPropsInjector>{(props) =>
                <AdminReserveConfirmPage
                    {...routesProps}
                    classification={ReservationClass.AGENT}
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'施設予約確認 | 素敵ネット 管理画面'}
                    headingAreaTitle={'代行予約'}
                    renderDetailsView={renderProps => (<ARDetailsView
                        eventEmitter={routesProps.eventEmitter} {...renderProps}/>)}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/condominiums/:condominiumCd/agent-reserve/complete"
            element={<RouterPropsInjector>{(props) =>
                <AdminReserveCompletePage
                    {...routesProps}
                    classification={ReservationClass.AGENT}
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'施設予約完了 | 素敵ネット 管理画面'}
                    headingAreaTitle={'代行予約'}
                    renderDetailsView={renderProps => (<ARDetailsView {...renderProps}/>)}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/condominiums/:condominiumCd/manager-reserve/select-facility"
            element={<RouterPropsInjector>{(props) =>
                <AdminReserveSelectFacilityPage
                    {...routesProps}
                    classification={ReservationClass.MANAGER}
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'施設予約TOP | 素敵ネット 管理画面'}
                    headingAreaTitle={'管理者予約'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/condominiums/:condominiumCd/manager-reserve/select-user"
            element={<RouterPropsInjector>{(props) =>
                <AdminManagerReserveSelectUserPage
                    {...routesProps}
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'利用者選択 | 素敵ネット 管理画面'}
                    headingAreaTitle={'管理者予約'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/condominiums/:condominiumCd/manager-reserve/select-option"
            element={<RouterPropsInjector>{(props) =>
                <AdminReserveSelectOptionPage
                    {...routesProps}
                    classification={ReservationClass.MANAGER}
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'オプション選択 | 素敵ネット 管理画面'}
                    headingAreaTitle={'管理者予約'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/condominiums/:condominiumCd/manager-reserve/confirm"
            element={<RouterPropsInjector>{(props) =>
                <AdminReserveConfirmPage
                    {...routesProps}
                    classification={ReservationClass.MANAGER}
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'施設予約確認 | 素敵ネット 管理画面'}
                    headingAreaTitle={'管理者予約'}
                    renderDetailsView={renderProps => (<ARDetailsView
                        eventEmitter={routesProps.eventEmitter} {...renderProps}/>)}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/condominiums/:condominiumCd/manager-reserve/complete"
            element={<RouterPropsInjector>{(props) =>
                <AdminReserveCompletePage
                    {...routesProps}
                    classification={ReservationClass.MANAGER}
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'施設予約完了 | 素敵ネット 管理画面'}
                    headingAreaTitle={'管理者予約'}
                    renderDetailsView={renderProps => (<ARDetailsView {...renderProps}/>)}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/condominiums/:condominiumCd/meetings/register"
            element={<RouterPropsInjector>{(props) =>
                <AdminRegisterMeetingPage
                    {...routesProps}
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    pageTitle={'会議登録 | 素敵ネット 管理画面'}
                    headingAreaTitle={'会議登録'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/condominiums/:condominiumCd/meetings"
            element={<RouterPropsInjector>{(props) =>
                <AdminMeetingListPage
                    {...routesProps}
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    location={props.location}
                    pageTitle={'会議詳細 | 素敵ネット 管理画面'}
                    headingAreaTitle={'会議詳細'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/condominiums/:condominiumCd/meetings/:meetingId/edit"
            element={<RouterPropsInjector>{(props) =>
                <AdminEditMeetingPage
                    {...routesProps}
                    condominiumCd={props.params.condominiumCd!}
                    meetingId={Number(props.params.meetingId!)}
                    navigate={props.navigate}
                    pageTitle={'会議編集 | 素敵ネット 管理画面'}
                    headingAreaTitle={'会議編集'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/notification/meeting"
            element={<RouterPropsInjector>{(props) =>
                <AdminMeetingNotificationListPage
                    {...routesProps}
                    navigate={props.navigate}
                    pageTitle={'理事会通知設定 | 素敵ネット 管理画面'}
                    headingAreaTitle={'理事会通知設定'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/condominiums/:condominiumCd/assoc-terms"
            element={<RouterPropsInjector>{(props) =>
                <AdminAssocTermListPage
                    {...routesProps}
                    location={props.location}
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    pageTitle={'理事会の任期一覧 | 素敵ネット 管理画面'}
                    headingAreaTitle={'理事会の任期一覧'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/condominiums/:condominiumCd/assoc-terms/register"
            element={<RouterPropsInjector>{(props) =>
                <AdminRegisterAssocTermPage
                    {...routesProps}
                    location={props.location}
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    pageTitle={'理事会の任期登録 | 素敵ネット 管理画面'}
                    headingAreaTitle={'理事会の任期登録'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/condominiums/:condominiumCd/assoc-terms/edit"
            element={<RouterPropsInjector>{(props) =>
                <AdminEditAssocTermPage
                    {...routesProps}
                    location={props.location}
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    pageTitle={'理事会の任期編集 | 素敵ネット 管理画面'}
                    headingAreaTitle={'理事会の任期編集'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/condominiums/:condominiumCd/assoc-directors"
            element={<RouterPropsInjector>{(props) =>
                <AdminAssocDirectorListPage
                    {...routesProps}
                    location={props.location}
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    pageTitle={'役員一覧 | 素敵ネット 管理画面'}
                    headingAreaTitle={'役員一覧'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/condominiums/:condominiumCd/assoc-directors/register"
            element={<RouterPropsInjector>{(props) =>
                <AdminRegisterAssocDirectorPage
                    {...routesProps}
                    location={props.location}
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    pageTitle={'役員登録 | 素敵ネット 管理画面'}
                    headingAreaTitle={'役員登録'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/condominiums/:condominiumCd/assoc-director-positions"
            element={<RouterPropsInjector>{(props) =>
                <AdminAssocDirectorPositionListPage
                    {...routesProps}
                    location={props.location}
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    pageTitle={'役職設定 | 素敵ネット 管理画面'}
                    headingAreaTitle={'役職設定'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/condominiums/:condominiumCd/unit-owners"
            element={<RouterPropsInjector>{(props) =>
                <AdminUnitOwnerListPage
                    {...routesProps}
                    location={props.location}
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    pageTitle={'区分所有者一覧 | 素敵ネット 管理画面'}
                    headingAreaTitle={'区分所有者一覧'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/condominiums/:condominiumCd/voting-rights-count/bulk-update"
            element={<RouterPropsInjector>{(props) =>
                <AdminVotingRightsCountBulkUpdatePage
                    {...routesProps}
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    pageTitle={'議決権数の一括更新 | 素敵ネット 管理画面'}
                    headingAreaTitle={'議決権数の一括更新'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/condominiums/:condominiumCd/general-meetings/register"
            element={<RouterPropsInjector>{(props) =>
                <AdminGeneralMeetingRegisterPage
                    {...routesProps}
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    pageTitle={'総会登録 | 素敵ネット 管理画面'}
                    headingAreaTitle={'総会登録'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/condominiums/:condominiumCd/general-meetings/:generalMeetingId/edit"
            element={<RouterPropsInjector>{(props) =>
                <AdminGeneralMeetingEditPage
                    {...routesProps}
                    condominiumCd={props.params.condominiumCd!}
                    generalMeetingId={Number(props.params.generalMeetingId)}
                    navigate={props.navigate}
                    pageTitle={'総会編集 | 素敵ネット 管理画面'}
                    headingAreaTitle={'総会編集'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/condominiums/:condominiumCd/general-meetings"
            element={<RouterPropsInjector>{(props) =>
                <AdminGeneralMeetingListPage
                    {...routesProps}
                    location={props.location}
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    pageTitle={'総会一覧 | 素敵ネット 管理画面'}
                    headingAreaTitle={'総会一覧'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/condominiums/:condominiumCd/general-meetings/:generalMeetingId"
            element={<RouterPropsInjector>{(props) =>
                <AdminGeneralMeetingDetailPage
                    {...routesProps}
                    location={props.location}
                    condominiumCd={props.params.condominiumCd!}
                    generalMeetingId={Number(props.params.generalMeetingId!)}
                    navigate={props.navigate}
                    pageTitle={'総会詳細 | 素敵ネット 管理画面'}
                    headingAreaTitle={'総会詳細'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/condominiums/:condominiumCd/general-meetings/unit-owner-confirmation-key/issue"
            element={<RouterPropsInjector>{(props) =>
                <AdminUnitOwnerConfirmationKeyIssuePage
                    {...routesProps}
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    pageTitle={'区分所有者確認用キー発行 | 素敵ネット 管理画面'}
                    headingAreaTitle={'区分所有者確認用キー発行'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/admin/support-sp-test"
            element={<RouterPropsInjector>{(props) =>
                <AdminSupportSpTestPage
                    {...routesProps}
                    supportSp
                    location={props.location}
                    navigate={props.navigate}
                    pageTitle={'スマホ対応画面テスト | 素敵ネット 管理画面'}
                    headingAreaTitle={'スマホ対応画面テスト'}
                />
            }</RouterPropsInjector>}
        />
    </>)
}
